import { styled } from 'styled-components';

import { breakpointLargeTablet } from 'src/styles/breakpoints';
import { colorSecondary900, colorSpinner } from 'src/styles/colors';

export const StyledContainer = styled.div`
  width: 100%;
  height: 100%;
  min-height: 600px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledSpinner = styled.div`
  border: 5px solid ${colorSpinner};
  border-top-color: ${colorSecondary900};
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 1.4s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  @media (min-width: ${breakpointLargeTablet}) {
    width: 120px;
    height: 120px;
  }
`;
